import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchQuestionnaireResultsArgs,
  FetchQuestionnaireByIdArgs,
  FetchQuestionnairesArgs,
} from '../api/types/questionnaires.types';

import {
  fetchQuestionnaireResults,
  fetchQuestionnaireById,
  fetchQuestionnaires,
} from '../api/questionnaires.api';

export const questionnairesQueryKeys = createQueryKeys('questionnaires', {
  fetchQuestionnaireById: ({
    id,
    organizationId,
  }: FetchQuestionnaireByIdArgs) => ({
    queryFn: () => fetchQuestionnaireById({ id, organizationId }),
    queryKey: [organizationId, id],
  }),
  fetchQuestionnaireResults: ({
    id,
    organizationId,
  }: FetchQuestionnaireResultsArgs) => ({
    queryFn: () => fetchQuestionnaireResults({ id, organizationId }),
    queryKey: [organizationId, id],
  }),
  fetchQuestionnaires: ({
    organizationId,
    status,
  }: FetchQuestionnairesArgs) => ({
    queryFn: () => fetchQuestionnaires({ organizationId, status }),
    queryKey: [organizationId, status],
  }),
});
